import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const workspacePaymentApi = createApi({
  reducerPath: "workspacePaymentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  tagTypes: ["PaymentProcessor"],
  endpoints: (builder) => ({
    getPaymentProcessor: builder.query({
      query: ({ workspaceId }) => `/workspaces/${workspaceId}/payment-processor`,
      providesTags: (result, error, { workspaceId }) => [
        { type: "PaymentProcessor", id: workspaceId },
      ],
    }),
    exchangeStripeOAuth: builder.mutation({
      query: (body) => ({
        url: "/workspaces/payment-processor/stripe/oauth",
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { workspaceId }) => [
        { type: "PaymentProcessor", id: workspaceId },
      ],
    }),
    disconnectProcessor: builder.mutation({
      query: (body) => ({
        url: "/workspaces/payment-processor/disconnect",
        method: "POST",
        body,
      }),
      invalidatesTags: (result, error, { workspaceId }) => [
        { type: "PaymentProcessor", id: workspaceId },
      ],
    }),
    updateCurrency: builder.mutation({
      query: (body) => ({
        url: "/workspaces/payment-processor/currency",
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { workspaceId }) => [
        { type: "PaymentProcessor", id: workspaceId },
      ],
    }),
  }),
});

export const {
  useGetPaymentProcessorQuery,
  useExchangeStripeOAuthMutation,
  useDisconnectProcessorMutation,
  useUpdateCurrencyMutation,
} = workspacePaymentApi;
